// core/utils/flow-utils.ts
import { Router } from '@angular/router';

export type Flow = 'apps' | 'reseller' | 'office365' | 'cloud';

export function getFlowFromUrl(url: string): Flow {
  // Normalize the URL to always start with a slash and remove query strings
  const normalizedUrl = url.split('?')[0];

  // The logic for reseller must be first because its path is a subset of 'apps'
  if (normalizedUrl.includes('/apps/reseller')) {
    return 'reseller';
  }

  // The rest of the checks can then follow
  if (normalizedUrl.includes('/office365')) {
    return 'office365';
  }
  
  if (normalizedUrl.includes('/apps')) {
    return 'apps';
  }

  if (normalizedUrl.includes('/cloud')) {
    return 'cloud';
  }
  
  return 'apps'; // default flow
}



export function getCleanPath(router: Router): string {
  const tree = router.parseUrl(router.url);
  const primary = tree.root.children['primary'];
  return primary ? '/' + primary.segments.map(s => s.path).join('/') : router.url;
}
